import { useSuspenseHostsCount } from '#api/hosts.queries.ts';
import { useCapabilities } from '#global/context/capabilities/useCapabilities.ts';
import { FEATURE_UNLIMITED_FLAG } from '#util/flags.ts';

export function useSuspenseIsHostsLimitReached() {
  const { data: hostsCount } = useSuspenseHostsCount();
  const { capabilities } = useCapabilities();

  // We should have capabilities if we were able to fetch the host count, this should not happen
  if (capabilities === null) {
    throw new Error('Could not get host count and/or host limit');
  }
  const { hostsLimit } = capabilities;

  return {
    /** Have we reached or surpassed the {@link HOST_LIMIT}? */
    isHostsLimitReached: hostsLimit !== FEATURE_UNLIMITED_FLAG && hostsCount >= hostsLimit,
    hostsLimit,
  };
}
